import {
  DrawerScreens,
  RootStackParamList,
} from '$tablet-app/src/app/components/PrimaryNavigator';
import useRecordThumbnail from '$tablet-app/src/app/images/hooks/useRecordThumbnail';
import { ChatRecipeItem } from '@akin-home/chat';
import { OptionModel, OptionType } from '@akin-home/options';
import { useListOptionsByType } from '@akin-home/options/react';
import { useGetRecipe } from '@akin-home/recipes/react';
import { Text } from '@akin-home/text/native';
import {
  CompositeNavigationProp,
  NavigationProp,
  useNavigation,
} from '@react-navigation/native';
import styled from 'styled-components/native';
import ChatWidget from './ChatWidget';
import ChatWidgetHeader from './ChatWidgetHeader';

type NavProps = CompositeNavigationProp<
  NavigationProp<DrawerScreens>,
  NavigationProp<RootStackParamList>
>;

interface Props {
  chat_item: ChatRecipeItem;

  onClose?(): void;
}

export const ChatRecipesItem = (props: Props) => {
  const {
    chat_item: {
      data: { items },
    },
    onClose,
  } = props;

  const { navigate } = useNavigation<NavProps>();

  const { data: special_diets } = useListOptionsByType({
    type: OptionType.SPECIAL_DIET,
  });

  const onPressRecipe = (recipe_id: string) => {
    navigate('RecipeDetails', { recipe_id });
    onClose?.();
  };

  return (
    <ChatWidget
      header={<ChatWidgetHeader icon={'salad'} header_text="RECIPES" />}
      children={items.map((item) => (
        <RecipeItem
          key={item.item_id}
          id={item.item_id}
          special_diets={special_diets}
          onPress={onPressRecipe}
        />
      ))}
    />
  );
};

const RecipeItem = (props: {
  id: string;
  special_diets?: OptionModel[];
  onPress(id: string): void;
}) => {
  const { data } = useGetRecipe({ id: props.id });

  const { source } = useRecordThumbnail({ record: data });

  const special_diet_text = props.special_diets
    ?.filter((diet) => data?.specialDietIDs?.includes(diet.id))
    ?.map((diet) => diet.label)
    .join(', ');

  const onPress = () => props.onPress(props.id);

  return data ? (
    <Body onPress={onPress}>
      {source ? <Image source={source} /> : null}

      <BodyContent>
        <Text variant="h3" weight="bold" color="white">
          {data.name}
        </Text>

        {special_diet_text ? (
          <Text weight="semibold" color="white">
            {special_diet_text}
          </Text>
        ) : null}
      </BodyContent>
    </Body>
  ) : null;
};

const Body = styled.TouchableOpacity`
  flex-direction: row;
  padding: 15px;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
`;

const BodyContent = styled.View`
  flex: 1;
  min-width: 60%;
  gap: 10px;
`;

const Image = styled.Image`
  height: 100px;
  width: 100px;
  border-radius: 10px;
`;
